import React, { Component } from "react";
import styled from "styled-components";

import CircularProgress from "@material-ui/core/CircularProgress";

const Wrapper = styled.div`
  width: 100%;
  padding: 25vh 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

class Loader extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Wrapper>
        <CircularProgress
          size={75}
          style={{ color: "#3949ab" }}
          thickness={5}
        />
      </Wrapper>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js